import React from 'react';
import { Target, TrendingUp, Weight, Heart, Clock } from 'lucide-react';

const GoalSelector = ({ selectedGoal, onGoalChange }) => {
  const goals = [
    { 
      id: 'weight-loss', 
      name: 'Weight Loss', 
      description: 'Burn calories and reduce body fat',
      icon: <Weight size={24} className="text-accent" />,
      dailySteps: '10,000+',
      intensity: 'Moderate'
    },
    { 
      id: 'endurance', 
      name: 'Endurance', 
      description: 'Build stamina and cardiovascular health',
      icon: <TrendingUp size={24} className="text-accent" />,
      dailySteps: '12,000+',
      intensity: 'High'
    },
    { 
      id: 'health', 
      name: 'General Health', 
      description: 'Maintain fitness and overall wellbeing',
      icon: <Heart size={24} className="text-accent" />,
      dailySteps: '8,000+',
      intensity: 'Low to Moderate'
    },
    { 
      id: 'stress', 
      name: 'Stress Relief', 
      description: 'Mental health and relaxation focus',
      icon: <Clock size={24} className="text-accent" />,
      dailySteps: '6,000+',
      intensity: 'Low'
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-xl font-semibold mb-4 flex items-center">
        <Target size={20} className="mr-2 text-primary" />
        Fitness Goals
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {goals.map(goal => (
          <div 
            key={goal.id}
            onClick={() => onGoalChange(goal.id)}
            className={`border rounded-lg p-4 cursor-pointer transition-all ${
              selectedGoal === goal.id ? 'border-primary bg-primary/5' : 'hover:bg-gray-50'
            }`}
          >
            <div className="flex items-start">
              <div className="p-2 bg-gray-100 rounded-full mr-3">
                {goal.icon}
              </div>
              <div>
                <h3 className="font-medium">{goal.name}</h3>
                <p className="text-sm text-gray-500">{goal.description}</p>
                
                <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
                  <div>
                    <p className="text-gray-500">Target Steps:</p>
                    <p className="font-medium">{goal.dailySteps}</p>
                  </div>
                  <div>
                    <p className="text-gray-500">Intensity:</p>
                    <p className="font-medium">{goal.intensity}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoalSelector;